import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { Link } from "react-router-dom";
import Table from "../../../../core/common/dataTable";
import { all_routes } from "../../../router/all_routes";
import { getAllJobNatures } from "../../../../core/data/redux/jobNaturesSlice";

type AppDispatch = ThunkDispatch<any, any, AnyAction>;

export interface IJobNature {
  id: string;
  natureId?: string;
  natureTitle?: string;
  created_at?: string;
  modified_at?: string;
}

interface Pagination {
  current: number;
  pageSize: number;
  total: number;
}

interface SearchParams {
  query: string;
}

const JobNatures = () => {
  const dispatch = useDispatch<AppDispatch>();
  const jobNaturesState = useSelector((state: any) => state.jobNaturesState);
  const routes = all_routes;

  const [dataList, setDataList] = useState<IJobNature[]>([]);
  const [searchParams, setSearchParams] = useState<SearchParams>({ query: "" });
  const [pagination, setPagination] = useState<Pagination>({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    const delay = setTimeout(() => {
      setPagination((prev) => ({ ...prev, current: 1 }));
      fetchRecords(searchParams, pagination.current, pagination.pageSize);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchParams]);

  useEffect(() => {
    fetchRecords(searchParams, pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize]);

  const fetchRecords = useCallback(
    (params: SearchParams, current: number, pageSize: number) => {
      const payload: any = {
        page: current,
        limit: pageSize,
      };
      if (params.query.trim()) {
        payload.query = params.query.trim();
      }
      dispatch(getAllJobNatures(payload));
    },
    [dispatch]
  );

  useEffect(() => {
    const nestedData = jobNaturesState?.data;
    console.log(nestedData)
    if (nestedData.data) {
      setDataList(nestedData.data ?? []);
      setPagination((prev) => ({
        ...prev,
        total: nestedData.total ?? 0,
      }));
    }
  }, [jobNaturesState.data]);

  const handleSearch = (searchText: string) => {
    setSearchParams({ query: searchText });
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      key: "srNo",
      render: (_text: any, _record: any, index: number) =>
        index + 1 + (pagination.current - 1) * pagination.pageSize,
    },
    {
      title: "Nature ID",
      dataIndex: "natureId",
      key: "natureId",
    },
    {
      title: "Nature Title",
      dataIndex: "natureTitle",
      key: "natureTitle",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (date: string) => (date ? new Date(date).toLocaleString() : "-"),
    },
    {
      title: "Modified At",
      dataIndex: "modified_at",
      key: "modified_at",
      render: (date: string) => (date ? new Date(date).toLocaleString() : "-"),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <h3 className="page-title mb-1">Job Natures</h3>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={routes.adminDashboard}>Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Job Natures</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <Table
              columns={columns}
              dataSource={dataList}
              loading={jobNaturesState.isLoading}
              paginationConfig={pagination}
              handlePagination={setPagination}
              Selection={false}
              handleSearch={handleSearch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobNatures;
